import React, {useEffect, useState} from "react";
import ReactDOM from "react-dom";
import {useNavigate, useParams} from "react-router-dom";
import {formatDate, onlyNumericInput, useFormInput, validateCarYear,} from "@/utils";
import {
    useGetAddressCode2Mutation,
    useGetAddressCodeQuery,
    useGetCarClassQuery,
    useGetCarGubunQuery,
    useGetCarManufacturerQuery,
    useGetCarModelDetailQuery,
    useGetCarModelQuery,
    useGetCarTrimQuery,
    useGetFuelListQuery,
    useGetRentPriceTableQuery,
    useLazyGetRentPriceTableQuery,
} from "@/redux/metaApi";
import {useGetInsuranceCorpQuery} from "@/redux/insuranceCorpApi";
import {
    carYearOptions,
    chargeRateOptions,
    displacementOptions,
    expectFaultOptions,
    orderMethodOptions,
    orderTypeOptions,
    originOptions,
} from "@/constants/selectOptions";

import {Confirm, Toast} from "@/components";
import SearchAddress from "@/components/Modal/Common/SearchAddress";
import Select from "react-select";
import {useGetSearchRentCorpMutation} from "@/redux/rentCorpApi";
import {usePostOrderMutation} from "@/redux/orderApi";

export const OrderRegister = () => {
    const { vehicleId } = useParams();
    const navigate = useNavigate();

    const [postOrder, { data: postData, isLoading: postIsLoading, error: postError }] = usePostOrderMutation();

    const { formData, handleChange, setFormData } = useFormInput({
        // 공통
        mode: "CREATE", // "CREATE" / "READ" / "UPDATE"
        toastMsg: "",
        confirmStatus: {
            confirmPopupStatus: false,
            confirmTitle: "",
            confirmDescription: "",
            confirmButtons: [],
        },
        partnersPopupStatus: false,
        addressPopupStatus: false,
        id: null,

        orderType: "INSURANCE_RENT",
        orderMethod: "ALL",
        selectedPartnerName: "",
        insuranceAgeOptions: [
            { value: "OVER21", label: "만 21세 이상" },
            { value: "OVER26", label: "만 26세 이상" },
        ],

        // POST API
        rentCorpId: "",
        carNumber: "",
        cho: "",
        carGubun: "",
        bmNo: "",
        boiNo: "",
        boNo: "",
        bsNo: "",
        bdNo: "",
        year: "",
        displacement: 0,
        orderCustomer: {
            name: "",
            phone: "",
            location1AddressCodeId: "",
            location2AddressCodeId: "",
            birthDate: "",
        },
        orderInsurance: {
            insuranceCorpName: "",
            receiptNumber: "",
            expectFault: 0,
            expectCommission: 0,
            chargeRate: 65,
            chargeMethod: null,
            memo: "",
            noCommission: false,
        },
        orderCharge: {
            chargeMethod: "",
            chargeRate: 0,
            memo: "",
        },
        orderMechanic: {
            mechanicCorpName: "",
            phone: "",
            address: "",
            addressDetail: "",
            bCode: "",
            bcode: "",
        },
    });

    const {
        mode,
        toastMsg,
        confirmStatus,
        partnersPopupStatus,
        addressPopupStatus,
        id,

        selectedPartnerName,
        insuranceAgeOptions,

        rentCorpId,
        carNumber,
        cho,
        carGubun,
        bmNo,
        boiNo,
        boNo,
        bsNo,
        bdNo,
        displacement,
        orderCustomer,
        orderInsurance,
        orderCharge,
        orderMechanic,
    } = formData;

    useEffect(() => {
        console.log(formData);
    }, [formData]);

    const showConfirm = (title, description, buttons) => {
        setFormData((prev) => ({
            ...prev,
            confirmStatus: {
                confirmPopupStatus: true,
                confirmTitle: title,
                confirmDescription: description,
                confirmButtons: buttons,
            },
        }));
    };

    const handleDeleteConfirm = async () => {
        try {
            showConfirm("삭제가 완료되었습니다.", "", [
                {
                    label: "확인",
                    className: "btn-primary",
                    onClick: () =>
                        setFormData((prev) => ({
                            ...prev,
                            confirmStatus: { confirmPopupStatus: false },
                        })),
                },
            ]);
        } catch (error) {
            console.error("Failed to delete vehicle:", error);
        }
    };

    const handleDelete = () => {
        showConfirm(`해당 차량 정보를 삭제하시겠습니까?`, "삭제 후에는 복구할 수 없습니다.", [
            { label: "예", className: "btn-primary", onClick: handleDeleteConfirm },
            {
                label: "아니오",
                className: "btn-cancel",
                onClick: () =>
                    setFormData((prev) => ({
                        ...prev,
                        confirmStatus: { confirmPopupStatus: false },
                    })),
            },
        ]);
    };

    const handleSaveConfirm = async () => {
        setFormData((prev) => ({
            ...prev,
            confirmStatus: { confirmPopupStatus: false },
        }));
        const actionText = mode === "CREATE" ? "등록" : "수정";

        try {
            const vehicleDataToSave = {};

            showConfirm(`${actionText}이 완료되었습니다.`, "", [
                {
                    label: "확인",
                    className: "btn-primary",
                    onClick: () =>
                        setFormData((prev) => ({
                            ...prev,
                            confirmStatus: { confirmPopupStatus: false },
                        })),
                },
            ]);
        } catch (error) {
            // setFormData((prev) => ({ ...prev, toastMsg: error?.message || "에러 발생" }));
            console.error(`Failed to ${actionText} vehicle:`, error);
        }
    };

    const validateOrder = () => {
        if (formData.orderMethod === "SELECT") {
            if (!formData.rentCorpId) {
                setFormData((prev) => ({ ...prev, toastMsg: "지정 파트너사를 선택해주세요." }));
                return false;
            }
        }

        if (!formData.orderType) {
            setFormData((prev) => ({ ...prev, toastMsg: "요청 구분을 입력해주세요." }));
            return false;
        }
        if (!formData.orderMethod) {
            setFormData((prev) => ({ ...prev, toastMsg: "요청 방식을 입력해주세요." }));
            return false;
        }
        if (!formData.orderCustomer?.phone) {
            setFormData((prev) => ({ ...prev, toastMsg: "연락처를 입력해주세요." }));
            return false;
        }
        if (!formData.orderCustomer?.location1AddressCodeId) {
            setFormData((prev) => ({ ...prev, toastMsg: "1차 이용 지역을 선택해주세요." }));
            return false;
        }
        if (!formData.orderCustomer?.location2AddressCodeId) {
            setFormData((prev) => ({ ...prev, toastMsg: "2차 이용 지역을 선택해주세요." }));
            return false;
        }
        if (!formData.carNumber || formData.carNumber.trim() === "") {
            setFormData((prev) => ({ ...prev, toastMsg: "차량번호를 입력해주세요." }));
            return false;
        }

        if (!formData.cho || formData.cho.trim() === "") {
            setFormData((prev) => ({ ...prev, toastMsg: "국산/수입을 선택해주세요." }));
            return false;
        }
        if (!formData.carGubun || formData.carGubun.trim() === "") {
            setFormData((prev) => ({ ...prev, toastMsg: "차종을 선택해주세요." }));
            return false;
        }
        if (!formData.displacement) {
            setFormData((prev) => ({ ...prev, toastMsg: "배기량을 선택해주세요." }));
            return false;
        }
        if (!formData.bmNo || formData.bmNo.trim() === "") {
            setFormData((prev) => ({ ...prev, toastMsg: "제조사를 입력해주세요." }));
            return false;
        }
        if (!formData.boiNo || formData.boiNo.trim() === "") {
            setFormData((prev) => ({ ...prev, toastMsg: "모델을 입력해주세요." }));
            return false;
        }
        // if (!formData.boNo || formData.boNo.trim() === "") {
        //     setFormData((prev) => ({ ...prev, toastMsg: "상세모델을 입력해주세요." }));
        //     return false;
        // }

        if (!formData.orderInsurance?.insuranceCorpId) {
            setFormData((prev) => ({ ...prev, toastMsg: "보험사를 선택해주세요." }));
            return false;
        }
        /*
        if (!formData.orderInsurance?.receiptNumber) {
            setFormData((prev) => ({ ...prev, toastMsg: "접수번호를 입력해주세요." }));
            return false;
        }
         */

        if (!formData.orderInsurance?.prefixNumber) {
            setFormData((prev) => ({ ...prev, toastMsg: "접수번호를 입력해주세요." }));
            return false;
        }

        if (!formData.orderInsurance?.expectFault) {
            setFormData((prev) => ({ ...prev, toastMsg: "예상 과실을 선택해주세요." }));
            return false;
        }
        if (!formData.orderInsurance?.chargeMethod) {
            setFormData((prev) => ({ ...prev, toastMsg: "청구 방식을 선택해주세요." }));
            return false;
        }
        if (!formData.orderCharge) {
            setFormData((prev) => ({ ...prev, toastMsg: "청구율을 선택해주세요." }));
            return false;
        }
        return true;
    };

    const handleSave = () => {
        if (!validateOrder()) return;

        const actionText = mode === "CREATE" ? "생성" : "수정";

        let processedExpectCommission = formData.orderInsurance.expectCommission;
        if (typeof processedExpectCommission === "string") {
            if (processedExpectCommission.includes("추후산정")) {
                processedExpectCommission = -1;
            } else {
                // "%" 문자 제거 후 숫자로 변환 (예: "10%" -> 10)
                processedExpectCommission = Number(processedExpectCommission.replace("%", ""));
            }
        }

        const body = {
            orderType: formData.orderType,
            orderMethod: formData.orderMethod,
            rentCorpId: formData.rentCorpId,
            carNumber: formData.carNumber,
            cho: formData.cho,
            carGubun: formData.carGubun,
            bmNo: formData.bmNo,
            boiNo: formData.boiNo,
            boNo: formData.boNo,
            bsNo: formData.bsNo,
            bdNo: formData.bdNo,
            displacement: formData.displacement,
            orderCustomer: formData.orderCustomer,
            orderInsurance: {
                ...formData.orderInsurance,
                // 예상 과실을 전처리된 값으로 설정
                expectFault: Number(formData.orderInsurance.expectFault),
                expectCommission: processedExpectCommission,
                prefixNumber: formData.orderInsurance?.prefixNumber,
                receiptAddNumber: formData.orderInsurance?.receiptAddNumber,
            },
            orderCharge: formData.orderCharge,
            orderMechanic: formData.orderMechanic,
        };

        showConfirm(`오더를 ${actionText} 하시겠습니까?`, "", [
            {
                label: "예",
                className: "btn-primary",
                onClick: async () => {
                    const res = await postOrder(body);
                    setFormData((prev) => ({
                        ...prev,
                        confirmStatus: { confirmPopupStatus: false },
                    }));
                    if (res.error) {
                        setFormData((prev) => ({
                            ...prev,
                            toastMsg: res.error.message,
                        }));
                        return;
                    }
                    if (res.data) {
                        showConfirm("오더가 생성되었습니다.", "", [
                            {
                                label: "확인",
                                className: "btn-primary",
                                onClick: () => navigate("/order/manage"),
                            },
                        ]);
                    }
                },
            },
            {
                label: "아니오",
                className: "btn-cancel",
                onClick: () =>
                    setFormData((prev) => ({
                        ...prev,
                        confirmStatus: { confirmPopupStatus: false },
                    })),
            },
        ]);
    };

    useEffect(() => {
        if (vehicleId) {
            // getVehicleById({ vehicleId });
            // 실제 API 호출 로직
            setFormData((prev) => ({
                ...prev,
                mode: "READ",
                id: vehicleId,
            }));
        }
    }, [vehicleId, setFormData]);

    return (
        <>
            {toastMsg && <Toast visible={true} msg={toastMsg} setFormData={setFormData} />}

            <div className="management-form container">
                <div className="form-container">
                    <div className="form-head">
                        <div className="head-tit">
                            <span className="form_name">{mode === "CREATE" ? "오더 생성" : "오더 상세"}</span>
                            <span className="form_desc"></span>
                        </div>
                        <div className="head-options">
                            {mode !== "CREATE" && (
                                <button type="button" className="btn btn-delete" onClick={handleDelete}>
                                    오더 삭제
                                </button>
                            )}
                            <button type="button" className="btn btn-outline" onClick={() => navigate(-1)}>
                                이전으로
                            </button>
                            <button type="button" className="btn btn-save" onClick={handleSave}>
                                생성
                            </button>
                        </div>
                    </div>

                    <div className="form-content">
                        <div className="form-wrapper">
                            {
                                /*
                            <div className="form-item">
                                <div className="item-head">
                                    <span className="form-item_tit">요청 정보</span>
                                    <div className="form-item_etc"></div>
                                </div>
                                <div className="item-body">
                                    <div className="item-list">
                                        <RequestInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                    </div>
                                </div>
                            </div>
                                 */
                            }


                            <div className="form-item">
                                <div className="item-head">
                                    <span className="form-item_tit">고객(운전자) 정보</span>
                                    <div className="form-item_etc"></div>
                                </div>
                                <div className="item-body">
                                    <div className="item-list">
                                        <DriverInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                    </div>
                                </div>
                            </div>

                            <div className="form-item">
                                <div className="item-head">
                                    <span className="form-item_tit">차량 정보</span>
                                    <div className="form-item_etc"></div>
                                </div>
                                <div className="item-body">
                                    <div className="item-list">
                                        <VehicleInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                    </div>
                                </div>
                            </div>

                            <div className="form-item">
                                <div className="item-head">
                                    <span className="form-item_tit">보험 정보</span>
                                    <div className="form-item_etc"></div>
                                </div>
                                <div className="item-body">
                                    <div className="item-list">
                                        <InsuranceInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                    </div>
                                </div>
                            </div>

                            <div className="form-item">
                                <div className="item-head">
                                    <span className="form-item_tit">공업사 정보</span>
                                    <div className="form-item_etc"></div>
                                </div>
                                <div className="item-body">
                                    <div className="item-list">
                                        <WorkshopInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                    </div>
                                </div>
                            </div>

                            <div className="form-item">
                                <div className="item-head">
                                    <span className="form-item_tit">청구 및 기타</span>
                                    <div className="form-item_etc"></div>
                                </div>
                                <div className="item-body">
                                    <div className="item-list">
                                        <ChargeInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Confirm 팝업 */}
            {confirmStatus.confirmPopupStatus && (
                <Confirm
                    layer={true}
                    onClose={() =>
                        setFormData((prev) => ({
                            ...prev,
                            confirmStatus: { confirmPopupStatus: false },
                        }))
                    }
                    title={confirmStatus.confirmTitle}
                    description={confirmStatus.confirmDescription}
                    buttons={confirmStatus.confirmButtons}
                />
            )}

            {/* 주소 검색 팝업 */}
            {addressPopupStatus && (
                <SearchAddress
                    modalStatus={addressPopupStatus}
                    setModalStatus={() =>
                        setFormData((prev) => ({
                            ...prev,
                            addressPopupStatus: false,
                        }))
                    }
                    setAddress={(data) => {
                        console.log(data);
                        setFormData((prev) => ({
                            ...prev,
                            orderMechanic: {
                                ...orderMechanic,
                                address: data.address,
                                bcode: data.bcode,
                                bCode: data.bcode,
                            },
                        }));
                    }}
                />
            )}

            {partnersPopupStatus && (
                <PartnersPopup
                    layer={true}
                    onClose={(value) => {
                        value.id ||
                            setFormData((prev) => ({
                                ...prev,
                                partnersPopupStatus: false,
                            }));
                        value.id &&
                            setFormData((prev) => ({
                                ...prev,
                                partnersPopupStatus: false,
                                rentCorpId: value.id,
                                selectedPartnerName: value.corpName,
                            }));
                    }}
                    formData={formData.productItemType}
                    handleChange={handleChange}
                    setFormData={setFormData}
                />
            )}
        </>
    );
};

/* 요청 구분 */
const RequestInfo = ({ formData, handleChange, setFormData }) => {
    const { orderType, orderMethod, selectedPartnerName } = formData;

    return (
        <>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        요청 구분 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            options={orderTypeOptions}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable={false}
                            placeholder="요청 구분"
                            value={orderTypeOptions?.find((option) => option.value === orderType)}
                            onChange={(option) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    orderType: option.value,
                                }));
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        요청 방식 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            options={orderMethodOptions}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable
                            placeholder="요청 방식"
                            value={orderMethodOptions?.find((option) => option.value === orderMethod)}
                            onChange={(option) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    orderMethod: option.value,
                                }));
                            }}
                        />
                    </div>
                </div>
            </div>

            {orderMethod === "SELECT" ? (
                <div className="item-row" data-grow="3">
                    <div className="row-head">
                        <span>지정 파트너사</span>
                    </div>
                    <div className="row-content">
                        <div className="form-element">
                            <input
                                type="text"
                                name="selectedPartnerName"
                                placeholder=""
                                value={selectedPartnerName || ""}
                                onChange={handleChange}
                                readOnly
                                onClick={() => {
                                    setFormData((prevState) => ({
                                        ...prevState,
                                        partnersPopupStatus: true,
                                    }));
                                }}
                            />
                        </div>
                        <div className="form-element_button">
                            <button
                                type="button"
                                className="btn-form_element btn-outline"
                                onClick={() => {
                                    setFormData((prevState) => ({
                                        ...prevState,
                                        partnersPopupStatus: true,
                                    }));
                                }}
                            >
                                조회
                            </button>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="item-row" data-grow="3"></div>
            )}
        </>
    );
};

/* 차량 정보 */
const VehicleInfo = ({ formData, handleChange, setFormData }) => {
    const {
        carNumber,
        vehicleOrigin,
        carGubun,
        displacement,
        bdName,
        bdNo,
        bmName,
        bmNo,
        boName,
        boNo,
        boiName,
        boiNo,
        branchId,
        bsName,
        bsNo,
        year,
    } = formData;

    // 차종 옵션 (독립)
    const { data: carGubunData } = useGetCarGubunQuery();
    const carGubunOptions =
        carGubunData && carGubunData.data
            ? carGubunData.data.map((item) => ({
                  value: item.bgNo,
                  label: item.bgName,
              }))
            : [];

    // 제조사
    const { data: manufacturerData } = useGetCarManufacturerQuery({ bmNo: null, cho: formData.cho }, {skip: !formData.cho});
    const manufacturerOptions =
        manufacturerData?.data?.map((item) => ({
            value: item.bmNo,
            label: item.bmName,
            cho: item.cho
        })) || [];

    // 모델 (skip: !manufacturer)
    const { data: modelData } = useGetCarModelQuery({ bmNo: bmNo, carGubun: carGubun }, { skip: !bmNo });
    const modelOptions =
        modelData?.data?.map((item) => ({
            value: item.boiNo,
            label: item.boiName,
            carGubun: item.carGubun,
        })) || [];

    // 상세모델 (skip: !model)
    const { data: detailModelData } = useGetCarModelDetailQuery({ boiNo: boiNo }, { skip: !boiNo });
    const detailModelOptions =
        detailModelData?.data?.map((item) => ({
            value: item.boNo,
            label: item.boName,
        })) || [];

    // 등급 (skip: !detailModel)
    const { data: carClassData } = useGetCarClassQuery({ boNo: boNo }, { skip: !boNo });
    const carClassOptions =
        carClassData?.data?.map((item) => ({
            value: item.bsNo,
            label: item.bsName,
        })) || [];

    // 트림 (skip: !carClass)
    const { data: carTrimData } = useGetCarTrimQuery({ bsNo: bsNo }, { skip: !bsNo });
    const carTrimOptions =
        carTrimData?.data?.map((item) => ({
            value: item.bdNo,
            label: item.bdName,
        })) || [];

    // 유종 옵션 : getFuelList API
    const { data: fuelData } = useGetFuelListQuery();
    const fuelOptions =
        fuelData && fuelData.data
            ? fuelData.data.map((item) => ({
                  value: item.bfNo,
                  label: item.bfName,
              }))
            : [];

    // onChange 시 하위 필드를 초기화하는 helper
    const handleSelectChange = (field, option, clearFields = [], label) => {
        setFormData((prev) => ({
            ...prev,
            [field]: label || option.value,
            ...clearFields.reduce((acc, key) => {
                acc[key] = "";
                return acc;
            }, {}),
        }));
    };

    return (
        <>
            {/* 차량번호 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        차량번호 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input type="text" name="carNumber" placeholder="" value={carNumber} onChange={handleChange} />
                    </div>
                </div>
            </div>

            {/* 국산/수입 선택 */}

                <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        국산/수입 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            options={originOptions}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable={false}
                            placeholder="국산/수입 선택"
                            value={originOptions?.find((opt) => opt.value === vehicleOrigin)}
                            onChange={(option) => setFormData((prev) => ({
                                ...prev,
                                cho: option.value,
                                bmNo: "",
                                boiNo: "",
                                boNo: "",
                                bsNo: "",
                                bdNo: "",
                                carGubun: "",
                            }))}
                            //onChange={(option) => setFormData((prev) => ({ ...prev, cho: option.value }))}
                        />
                    </div>
                </div>
            </div>


            {/* 제조사 (독립; 제조사 선택 시 하위 초기화) */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        제조사<em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            placeholder="제조사 선택"
                            options={manufacturerOptions}
                            value={manufacturerOptions?.find((opt) => opt.value === bmNo) || ""}
                            onChange={(option) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    bmNo: option.value,
                                    boiNo: "",
                                    boNo: "",
                                    bsNo: "",
                                    bdNo: "",
                                    cho: option.cho,
                                    carGubun: "",
                                }));
                            }}
                            isDisabled={manufacturerOptions.length === 0}
                        />
                    </div>
                </div>
            </div>

            {/* 모델 (제조사 선택에 종속) */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        모델<em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            placeholder="모델 선택"
                            options={modelOptions}
                            value={modelOptions?.find((opt) => opt.value === boiNo) || ""}
                            onChange={(option) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    boiNo: option.value,
                                    boNo: "",
                                    bsNo: "",
                                    bdNo: "",
                                    carGubun: option.carGubun,
                                }))
                            }
                            isDisabled={modelOptions.length === 0}
                        />
                    </div>
                </div>
            </div>

            {/* 차종 (독립) */}

                <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        차종 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            options={carGubunOptions}
                            isSearchable
                            placeholder="차종 선택"
                            value={carGubunOptions?.find((opt) => opt.label === carGubun) || ""}
                            onChange={(option) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    carGubun: option.label,
                                    boiNo: "",
                                    boNo: "",
                                    bsNo: "",
                                    bdNo: "",
                                }));
                            }}
                            isDisabled={modelOptions.length === 0}
                        />
                    </div>
                </div>
            </div>



            {/* 상세모델 (모델 선택에 종속) */}
            {/* <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        상세모델<em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            placeholder="상세모델 선택"
                            options={detailModelOptions}
                            value={detailModelOptions?.find((opt) => opt.value === boNo)}
                            onChange={(option) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    boNo: option.value,
                                    bsNo: "",
                                    bdNo: "",
                                }))
                            }
                        />
                    </div>
                </div>
            </div> */}

            {/* 등급 (상세모델 선택에 종속) */}
            {/* <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>등급</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            placeholder="등급 선택"
                            options={carClassOptions}
                            value={carClassOptions?.find((opt) => opt.value === bsNo)}
                            onChange={(option) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    bsNo: option.value,
                                    bdNo: "",
                                }))
                            }
                        />
                    </div>
                </div>
            </div> */}

            {/* 트림 (등급 선택에 종속) */}
            {/* <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>트림</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            placeholder="트림 선택"
                            options={carTrimOptions}
                            value={carTrimOptions?.find((opt) => opt.value === bdNo)}
                            onChange={(option) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    bdNo: option.value,
                                }))
                            }
                        />
                    </div>
                </div>
            </div> */}

            {/* 배기량 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        배기량(cc) <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            placeholder="배기량 선택"
                            options={displacementOptions}
                            value={displacementOptions?.find((opt) => opt.value === displacement)}
                            onChange={(option) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    displacement: option.value,
                                }))
                            }
                        />
                    </div>
                </div>
            </div>

            {/* 차량 연식 */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>차량 연식</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            placeholder="차량 연식"
                            options={carYearOptions}
                            value={carYearOptions?.find((opt) => opt.value === year)}
                            onChange={(option) => {
                                // 선택된 연식이 현재 기준 8년 이상 지난 경우 메시지 반환
                                const errorMsg = validateCarYear(option.value);
                                if (errorMsg) {
                                    setFormData((prev) => ({
                                        ...prev,
                                        toastMsg: errorMsg,
                                    }));
                                }
                                setFormData((prev) => ({ ...prev, year: option.value }));
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

/* 고객 정보 */
const DriverInfo = ({ formData, handleChange, setFormData }) => {
    const { orderCustomer } = formData;

    const { data: loc1, isLoading: isLoadingLoc1 } = useGetAddressCodeQuery({ take_1_step: true, take_2_step: false });
    const [getAddressCode2, { data: loc2, isLoadingLoc2 }] = useGetAddressCode2Mutation();
    const [year, setYear] = useState(1980);

    return (
        <>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>고객 이름</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input type="text" name="orderCustomer.name" value={orderCustomer?.name} placeholder="" onChange={handleChange} />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        연락처 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="orderCustomer.phone"
                            value={orderCustomer?.phone}
                            placeholder=""
                            onChange={handleChange}
                            onInput={onlyNumericInput}
                            maxLength={11}
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3"></div>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        이용 지역 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            options={loc1?.data.map((item) => ({ value: item.id, label: item.address1, bcode: item.bCode }))}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable
                            placeholder="1차 지역"
                            // value={loc1?.data?.find((opt) => opt.id === orderCustomer?.location1AddressCodeId)?.address1}
                            onChange={(option) => {
                                getAddressCode2({ take_1_step: false, take_2_step: true, parent_b_code: option.bcode });
                                setFormData((prev) => ({
                                    ...prev,
                                    orderCustomer: {
                                        ...prev.orderCustomer,
                                        location1AddressCodeId: option.value,
                                    },
                                }));
                            }}
                        />
                    </div>
                    <div className="form-element">
                        <Select
                            options={loc2?.data.map((item) => ({ value: item.id, label: item.address2, bcode: item.bCode }))}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable
                            placeholder="2차 지역"
                            // value={loc2?.data?.find((opt) => opt.id === orderCustomer?.location2AddressCodeId)?.address2}
                            onChange={(option) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    orderCustomer: {
                                        ...prev.orderCustomer,
                                        location2AddressCodeId: option.value,
                                    },
                                }));
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>생년월일</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        {/* <Select
                            options={Array.from({ length: new Date().getFullYear() - 1900 + 1 }, (_, i) => 1900 + i).map((item) => ({ value: item, label: `${item}년` }))}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable
                            placeholder="연도선택"
                            onChange={(option) => {
                                setYear(option.value)
                                setFormData((prev) => ({
                                    ...prev,
                                    orderCustomer: {
                                        ...prev.orderCustomer,
                                        birthDate: dateFormatToISOString(new Date(option.value, 0, 1)).split("T")[0],
                                    },
                                }));
                            }}
                        /> */}
                        {/* <DatePicker
                            locale={ko}
                            showYearDropdown
                            scrollableYearDropdown
                            yearDropdownItemNumber={80}
                            selected={orderCustomer.birthDate}
                            dateFormat="yyyy.MM.dd"
                            onKeyDown={(e) => e.preventDefault()}
                            onChange={(e) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    orderCustomer: {
                                        ...prev.orderCustomer,
                                        birthDate: dateFormatToISOString(e).split("T")[0],
                                    },
                                }));
                            }}
                        /> */}

                        <input
                            type="text"
                            name="orderCustomer.birthDate"
                            value={formatDate(orderCustomer.birthDate)}
                            placeholder="ex) 20250101"
                            onChange={handleChange}
                            maxLength={10}
                        />
                    </div>
                    {/* <div className="form-element">
                        <input type="text" name="" placeholder="" value={"만 26세 이상"} onChange={handleChange} disabled />
                    </div> */}
                </div>
                {/*<div className="row-content">*/}
                {/*    <div className="form-element">*/}
                {/*        <input*/}
                {/*            type="text"*/}
                {/*            name="orderCustomer.birthDate"*/}
                {/*            value={orderCustomer?.birthDate}*/}
                {/*            placeholder=""*/}
                {/*            onChange={handleChange}*/}
                {/*        />*/}
                {/*    </div>*/}
                {/*    <div className="form-element">*/}
                {/*        <input type="text" name="" placeholder="" value={"만 26세 이상"} onChange={handleChange} disabled/>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
            <div className="item-row" data-grow="3"></div>
        </>
    );
};

/* 공업사 정보 */
const WorkshopInfo = ({ formData, handleChange, setFormData }) => {
    const { orderMechanic } = formData;

    const workshopOptions = [
        { value: "공업사1", label: "공업사1" },
        { value: "공업사2", label: "공업2" },
    ];

    return (
        <>
            {/*<div className="item-row" data-grow="3">*/}
            {/*    <div className="row-head">*/}
            {/*        <span>업체명</span>*/}
            {/*    </div>*/}
            {/*    <div className="row-content">*/}
            {/*        <div className="form-element">*/}
            {/*            <Select*/}
            {/*                options={workshopOptions}*/}
            {/*                className="custom-select"*/}
            {/*                classNamePrefix="custom-select"*/}
            {/*                isSearchable*/}
            {/*                placeholder="업체명"*/}
            {/*                value={workshopOptions?.find((opt) => opt.value === orderMechanic?.mechanicCorpName)}*/}
            {/*                onChange={(option) => {*/}
            {/*                    setFormData((prev) => ({*/}
            {/*                        ...prev,*/}
            {/*                        orderMechanic: {*/}
            {/*                            ...prev.orderMechanic,*/}
            {/*                            mechanicCorpName: option.value,*/}
            {/*                        },*/}
            {/*                    }));*/}
            {/*                }}*/}
            {/*            />*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>업체명</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="orderMechanic.mechanicCorpName"
                            value={orderMechanic?.mechanicCorpName}
                            placeholder=""
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>연락처</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input type="text" name="orderMechanic.phone" value={orderMechanic?.phone} placeholder="" onChange={handleChange} />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3"></div>

            <div className="item-row" data-grow="1">
                <div className="row-head">
                    <span>주소</span>
                </div>
                <div className="row-content">
                    <div className="form-element" style={{ width: "200px" }}>
                        <input
                            type="text"
                            placeholder=""
                            name="orderMechanic.bCode"
                            value={orderMechanic.bCode}
                            onChange={handleChange}
                            readOnly
                            onClick={() => {
                                setFormData((prevState) => ({
                                    ...prevState,
                                    addressPopupStatus: true,
                                }));
                            }}
                        />
                    </div>
                    <div className="form-element" style={{ width: "668px" }}>
                        <input
                            type="text"
                            placeholder=""
                            name="orderMechanic.address"
                            value={orderMechanic.address}
                            onChange={handleChange}
                            readOnly
                            onClick={() => {
                                setFormData((prevState) => ({
                                    ...prevState,
                                    addressPopupStatus: true,
                                }));
                            }}
                        />
                    </div>
                    <div className="form-element">
                        <input
                            type="text"
                            placeholder="상세 주소를 입력해주세요."
                            name="orderMechanic.addressDetail"
                            value={orderMechanic.addressDetail}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-element_button">
                        <button
                            type="button"
                            className="btn-form_element btn-outline"
                            onClick={() => {
                                setFormData((prevState) => ({
                                    ...prevState,
                                    addressPopupStatus: true,
                                }));
                            }}
                        >
                            주소검색
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

/* 청구 정보 */
const ChargeInfo = ({ formData, handleChange, setFormData }) => {
    const { orderInsurance } = formData;

    const targetOptions = [
        { value: "고객과 우선 통화", label: "고객과 우선 통화" },
        { value: "요청자와 우선 통화", label: "요청자와 우선 통화" },
    ];

    // 요금표 목록 조회
    const { data: rentPriceTableData } = useGetRentPriceTableQuery();
    const rentPriceTableOptions = [
        { value: "INSURANCE_BASE", label: "보험사기준" },
        ...(rentPriceTableData && rentPriceTableData.data
            ? rentPriceTableData.data.map((item) => ({
                  value: item.id,
                  label: item.name,
              }))
            : []),
    ];

    // lazy hook 선언: INSURANCE_BASE 선택 시 API 호출에 사용
    const [triggerGetRentPriceTable] = useLazyGetRentPriceTableQuery();

    return (
        <>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        청구 방식 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            options={rentPriceTableOptions}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable
                            placeholder={!formData.orderInsurance.insuranceCorpId ? "보험사를 먼저 선택해주세요." : "청구 방식 선택"}
                            isDisabled={!formData.orderInsurance.insuranceCorpId}
                            value={
                                orderInsurance?.chargeMethod === "INSURANCE_BASE"
                                    ? rentPriceTableOptions.find((opt) => opt.value === "INSURANCE_BASE")
                                    : rentPriceTableOptions.find((opt) => opt.value === orderInsurance?.rentPriceTableId)
                            }
                            onChange={(option) => {
                                if (option.value === "INSURANCE_BASE") {
                                    if (!formData.orderInsurance.insuranceCorpId) {
                                        setFormData((prev) => ({
                                            ...prev,
                                            toastMsg: "보험사를 먼저 선택해주세요.",
                                        }));
                                        return;
                                    } else {
                                        // INSURANCE_BASE 선택 시, getRentPriceTable API 호출
                                        triggerGetRentPriceTable({
                                            rent_price_type: "INSURANCE_BASE",
                                        })
                                            .unwrap()
                                            .then((response) => {
                                                console.log(response);
                                                // response.data 배열에서 matching insuranceCorp.id 찾기
                                                const matched = response.data.find(
                                                    (item) =>
                                                        item.insuranceCorp &&
                                                        item.insuranceCorp.id === formData.orderInsurance.insuranceCorpId
                                                );
                                                if (matched) {
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        orderInsurance: {
                                                            ...prev.orderInsurance,
                                                            chargeMethod: "INSURANCE_BASE",
                                                            rentPriceTableId: matched.id,
                                                        },
                                                    }));
                                                } else {
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        toastMsg: "해당 보험사에 맞는 요금표가 없습니다.",
                                                    }));
                                                }
                                            })
                                            .catch((error) => {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    toastMsg: error?.message || "요금표 조회에 실패하였습니다.",
                                                }));
                                            });
                                    }
                                } else {
                                    setFormData((prev) => ({
                                        ...prev,
                                        orderInsurance: {
                                            ...prev.orderInsurance,
                                            chargeMethod: "RENT_PRICE",
                                            rentPriceTableId: option.value,
                                        },
                                    }));
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        청구율 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            options={chargeRateOptions}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable
                            placeholder="청구율"
                            value={chargeRateOptions?.find((opt) => opt.value === orderInsurance?.chargeRate)}
                            onChange={(option) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    orderInsurance: {
                                        ...prev.orderInsurance,
                                        chargeRate: option.value,
                                    },
                                }));
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>통화대상</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            options={targetOptions}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable
                            placeholder="통화 대상"
                            value={targetOptions?.find((opt) => opt.value === orderInsurance?.callingTarget)}
                            onChange={(option) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    orderInsurance: {
                                        ...prev.orderInsurance,
                                        callingTarget: option.value,
                                    },
                                }));
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="1">
                <div className="row-head">
                    <span>요청사항</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <textarea
                            name="orderInsurance.memo"
                            placeholder="요청사항을 작성해주세요."
                            value={orderInsurance?.memo}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

/* 보험 정보 */
const InsuranceInfo = ({ formData, handleChange, setFormData }) => {
    const { insuranceAgeOptions, insuranceAge, orderInsurance, orderMethod } = formData;

    // API 호출: 보험사 업체 조회
    const { data: insuranceCorpData } = useGetInsuranceCorpQuery();
    const insuranceCorpOptions =
        insuranceCorpData && insuranceCorpData.data
            ? insuranceCorpData.data.map((item) => ({
                  value: item.id,
                  label: item.name,
                  receiptNumberPrefix: item.receiptNumberPrefix,
              }))
            : [];

    useEffect(() => {
        let newExpectCommission = "";
        // 수수료 없이 진행 체크된 경우
        if (orderInsurance.noCommission) {
            newExpectCommission = "0%";
        } else {
            // 예상 과실 옵션 찾기 (orderInsurance.expectFault가 셋팅되어 있어야 함)
            const faultOption = expectFaultOptions.find((opt) => opt.value === orderInsurance.expectFault);
            if (faultOption) {
                if (orderMethod === "ALL") {
                    newExpectCommission = faultOption.methodAll;
                } else if (orderMethod === "SELECT") {
                    newExpectCommission = faultOption.methodSelect;
                }
            }
        }
        if (orderInsurance.expectCommission !== newExpectCommission) {
            setFormData((prev) => ({
                ...prev,
                orderInsurance: {
                    ...prev.orderInsurance,
                    expectCommission: newExpectCommission,
                },
            }));
        }
    }, [formData.orderInsurance.expectFault, formData.orderMethod, formData.orderInsurance.noCommission]);

    return (
        <>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        보험사 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            options={insuranceCorpOptions}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable={true}
                            placeholder="보험사 선택"
                            value={insuranceCorpOptions.find((opt) => opt.label === orderInsurance?.insuranceCorpName)}
                            onChange={(option) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    orderInsurance: {
                                        ...prev.orderInsurance,
                                        insuranceCorpId: option.value,
                                        insuranceCorpName: option.label,
                                        // receiptNumber: option.receiptNumberPrefix,
                                        prefixNumber: option.receiptNumberPrefix,
                                    },
                                }));
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        접수번호 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    {/* <div className="form-element">
                        <input
                            type="text"
                            name="orderInsurance.receiptNumber"
                            value={orderInsurance?.receiptNumber}
                            placeholder=""
                            onChange={handleChange}
                        />
                    </div> */}
                    <div className="form-element">
                        <input
                            type="text"
                            name="orderInsurance.prefixNumber"
                            value={orderInsurance?.prefixNumber}
                            placeholder=""
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-element">
                        <input
                            type="text"
                            name="orderInsurance.receiptAddNumber"
                            value={orderInsurance?.receiptAddNumber}
                            placeholder=""
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>
                        예상 과실 <em>*</em>
                    </span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            options={expectFaultOptions}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable={false}
                            placeholder="예상 과실"
                            value={expectFaultOptions?.find((opt) => opt.value === insuranceCorpOptions?.expectFault)}
                            onChange={(option) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    orderInsurance: {
                                        ...prev.orderInsurance,
                                        expectFault: option.value,
                                    },
                                }));
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>예상 수수료율</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="orderInsurance.expectCommission"
                            value={orderInsurance?.expectCommission}
                            placeholder=""
                            onChange={handleChange}
                            disabled
                        />
                    </div>
                    <div className="form-element">
                        <div className="checkbox">
                            <input
                                type="checkbox"
                                id="noCommission"
                                name="orderInsurance.noCommission"
                                checked={orderInsurance.noCommission || false}
                                onChange={(e) =>
                                    setFormData((prev) => ({
                                        ...prev,
                                        orderInsurance: {
                                            ...prev.orderInsurance,
                                            noCommission: e.target.checked,
                                        },
                                    }))
                                }
                            />
                            <label htmlFor="noCommission">
                                <span>수수료 없이 진행</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3"></div>
            <div className="item-row" data-grow="3"></div>
        </>
    );
};
// 지정 파트너사 선택
const PartnersPopup = ({ layer = true, onClose, formData, setFormData }) => {
    useEffect(() => {
        document.body.classList.add("scroll-lock");

        return () => {
            document.body.classList.remove("scroll-lock");
        };
    }, []);

    const [query, setSearchKeyword] = useState("");
    const [selectedPartner, setSelectedPartner] = useState(null);
    const [getSearchRentCorp, { data: searchData, isLoading: isLoadingSearchRentCorp }] = useGetSearchRentCorpMutation();

    const handleConfirm = () => {
        if (!selectedPartner) {
            setFormData((prev) => ({ ...prev, toastMsg: "파트너사를 선택해주세요." }));
            return;
        }
        onClose(selectedPartner);
    };

    return ReactDOM.createPortal(
        <>
            <div className={layer ? "layer active" : "layer"} onClick={onClose}></div>

            <div className="popup service-popup">
                <div className="popup-head">
                    <div className="head-tit">
                        <span className="tit-main">파트너사 선택</span>
                    </div>
                    <div className="btn-close" onClick={onClose}></div>
                </div>
                <div className="popup-content">
                    <div className="table-container">
                        <div className="table-filter">
                            <div className="filter-row">
                                <div className="filter-item">
                                    <div className="item-content">
                                        <div className="item-input">
                                            <input
                                                type="text"
                                                placeholder="입력하세요."
                                                name="query"
                                                onChange={(e) => setSearchKeyword(e.target.value)}
                                            />
                                        </div>
                                        <div className="item-buttons">
                                            <button
                                                type="button"
                                                className="btn-search"
                                                onClick={(e) => getSearchRentCorp({ query: query })}
                                            >
                                                검색
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="table-content">
                            <div className="table-wrapper">
                                <div className="table">
                                    <table>
                                        <colgroup>
                                            <col width={"12%"} />
                                            <col width={"32%"} />
                                            <col width={"17%"} />
                                            <col width={"17%"} />
                                            <col width={"22%"} />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">선택</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">사업자명</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">대표자</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">지역</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">연락처</div>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!searchData ? (
                                                <tr>
                                                    <td colSpan="5" className="data-empty">
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">사업자를 검색해주세요.</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ) : searchData?.data?.length === 0 ? (
                                                <tr>
                                                    <td colSpan="5" className="data-empty">
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">데이터가 없습니다.</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ) : (
                                                searchData?.data?.map((item, index) => (
                                                    <tr key={`searchResult${index}`}>
                                                        <td>
                                                            <div className="cell">
                                                                <div className="input-checkbox">
                                                                    <div className="checkbox">
                                                                        <input
                                                                            type="checkbox"
                                                                            id={`partner_${item.id}`}
                                                                            name="partner"
                                                                            checked={selectedPartner?.id === item.id}
                                                                            onChange={() =>
                                                                                setSelectedPartner(
                                                                                    selectedPartner?.id === item.id ? null : item
                                                                                )
                                                                            }
                                                                        />
                                                                        <label htmlFor={`partner_${item.id}`}></label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell">
                                                                <div className="cell-desc">{item.corpName}</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell">
                                                                <div className="cell-desc">{item.repName}</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell">
                                                                <div className="cell-desc">{item.address}</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell">
                                                                <div className="cell-desc">{item.phone || ""}</div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="popup-bottom">
                    <button className="btn btn-primary btn-cancel" onClick={onClose}>
                        취소
                    </button>
                    <button className="btn btn-primary btn-confirm" onClick={handleConfirm}>
                        완료
                    </button>
                </div>
            </div>
        </>,
        document.body
    );
};
